import { render, staticRenderFns } from "./addTraceTemplate.vue?vue&type=template&id=fa52be5c&scoped=true"
import script from "./addTraceTemplate.vue?vue&type=script&lang=js"
export * from "./addTraceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa52be5c",
  null
  
)

export default component.exports